var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import get from "lodash/get";
import set from "lodash/set";
import uniq from "lodash/uniq";
import size from "lodash/size";
import isNil from "lodash/isNil";
import keyBy from "lodash/keyBy";
import merge from "lodash/merge";
import invert from "lodash/invert";
import remove from "lodash/remove";
import omitBy from "lodash/omitBy";
import { getUniqueCartItemId, getUniqueCartItemsByKey } from "../helpers";
import { hasAllowAllEvents } from "../../components/BookingForm/booking-form.helpers";
var ParticipantFormHandler = /** @class */ (function () {
    function ParticipantFormHandler(modelManager, dirtyForm, options) {
        this.modelManager = modelManager;
        this.dirtyForm = dirtyForm;
        this.options = options;
        this.dirtyValues = getUniqueCartItemsByKey(this.modelManager, this.getCartItems());
    }
    ParticipantFormHandler.prototype.getCartItems = function (state) {
        if (state === void 0) { state = this.dirtyForm; }
        return get(state, "booking_data.cart_items", []);
    };
    ParticipantFormHandler.prototype.setRootParticipantIndices = function (state) {
        var _this = this;
        var hasDefaultData = get(this.options, "isAdminIntegration", false) && state.hasDefaultParticipantData();
        var defaultParticipantsCount = get(this.options, "isAdminIntegration", false) ? get(state.getDefaultData(), "form_data.form_field.personal_data", []).length : 0;
        var startIndex = state.hasSavedParticipantData() || defaultParticipantsCount ? 0 : 1;
        var counter = startIndex;
        var defaultIndicesCounter = startIndex;
        var billRecipientIndex = (hasDefaultData ? state.deriveFixedBillRecipientIndexFromDirtyForm() : null) || state.billRecipientIndex;
        var samePeopleForAllEvents = (!state.mustHaveDifferingParticipants && !state.hasDifferingParticipants);
        state.availableRootCartItems.forEach(function (cartItem, index, self) {
            var existingIndices = [], timespanId = cartItem.timespanId, priceId = cartItem.priceId, parentPriceId = cartItem.parentPriceId, timespan = cartItem.timespan, participantCount = cartItem.participantCount, shouldNotCollectParticipantInformation = !!timespan && !timespan.shouldCollectParticipantInformation, forceExistingBillRecipient = shouldNotCollectParticipantInformation || (timespan === null || timespan === void 0 ? void 0 : timespan.shouldHideBillRecipient) || ((timespan === null || timespan === void 0 ? void 0 : timespan.bookableWithWaitingList) && timespan.isNonBindingWaitingList), maxParticipantCount = timespan ? Math.min(timespan.getMaxParticipantCount({ selectedSlot: cartItem.bookingSlot, allowAllEvents: hasAllowAllEvents(state) }), Number(participantCount)) : participantCount;
            cartItem.defaultIndices = new Array(+maxParticipantCount).fill("").map(function (_x, i) {
                if (forceExistingBillRecipient && i === 0) {
                    return billRecipientIndex;
                }
                if (samePeopleForAllEvents) {
                    return String(defaultIndicesCounter);
                }
                if (forceExistingBillRecipient && defaultIndicesCounter === Number(billRecipientIndex)) {
                    defaultIndicesCounter++;
                }
                return String(defaultIndicesCounter++);
            });
            var dirtyItem = get(_this.dirtyValues, getUniqueCartItemId(priceId, parentPriceId, timespanId));
            if (state.isLoadingCustomerData) {
                cartItem.personalDataIndex = [].concat(get(dirtyItem, "booking.personal_data_index", [])).filter(function (x) { return !isNil(x); }).map(String);
                return;
            }
            var useDefaultParticipants = !!state.defaultParticipantIndices && index === 0;
            var oldIndices = useDefaultParticipants
                ? state.defaultParticipantIndices
                : [];
            oldIndices = oldIndices.concat(get(dirtyItem, "booking.personal_data_index", [])).map(function (x, i) {
                if (isNaN(x))
                    return null;
                if (Number(x) > 0)
                    return String(Number(x));
                if (forceExistingBillRecipient && i === 0)
                    return String(Number(x));
                return (timespan === null || timespan === void 0 ? void 0 : timespan.useExistingParticipant) || defaultParticipantsCount > Number(x) ? String(Number(x)) : null;
            });
            oldIndices = !useDefaultParticipants && forceExistingBillRecipient && oldIndices.indexOf(billRecipientIndex) !== 0 ? [billRecipientIndex].concat(oldIndices) : oldIndices;
            oldIndices = uniq(oldIndices).filter(Boolean).slice(0, +maxParticipantCount).map(function (x) { return String(x); });
            if (samePeopleForAllEvents && index !== 0) {
                cartItem.personalDataIndex = __spreadArray([], self[0].personalDataIndex);
                return;
            }
            if (oldIndices.length === +maxParticipantCount) {
                cartItem.personalDataIndex = oldIndices;
                return;
            }
            cartItem.personalDataIndex = merge(new Array(+maxParticipantCount).fill(""), oldIndices).reduce(function (newIndices, index) {
                if (index != "" && oldIndices.includes(String(index))) {
                    existingIndices.push(String(index));
                    newIndices.push(String(index));
                    return newIndices;
                }
                while (existingIndices.includes(String(counter))) {
                    counter++;
                }
                existingIndices.push(String(counter));
                return newIndices.concat(String(counter++));
            }, []);
        });
    };
    ParticipantFormHandler.prototype.setExtraArticleIndices = function (state) {
        var _this = this;
        var allPricesById = keyBy(state.cartItems, "position.price_id");
        state.extraArticleCartItems.forEach(function (cartItem) {
            var priceId = cartItem.priceId, quantity = cartItem.quantity, parentPriceId = cartItem.parentPriceId;
            var rootCartItem = allPricesById[parentPriceId];
            if (rootCartItem.quantity === quantity) {
                cartItem.personalDataIndex = rootCartItem.personalDataIndex;
                return;
            }
            var dirtyItem = get(_this.dirtyValues, getUniqueCartItemId(priceId, parentPriceId, null));
            var oldIndices = [].concat(get(dirtyItem, "booking.personal_data_index", []))
                .filter(function (index) { var _a; return (_a = rootCartItem.personalDataIndex) === null || _a === void 0 ? void 0 : _a.includes(index); })
                .slice(0, Number(quantity));
            cartItem.personalDataIndex = merge(new Array(+quantity).fill(""), oldIndices);
        });
    };
    ParticipantFormHandler.prototype.setByPropsToState = function (fromState, toState, prop, defaultValueType) {
        if (defaultValueType === void 0) { defaultValueType = {}; }
        var shouldNotMerge = !fromState.filtered;
        var defaultValue = get(toState, prop);
        var value = get(fromState, prop, defaultValue);
        if (Array.isArray(defaultValue)) {
            defaultValueType = [];
            value = value.map(function (value) { return value || {}; });
        }
        if (!shouldNotMerge) {
            defaultValue = defaultValueType;
        }
        set(toState, prop, merge(defaultValueType, defaultValue, value));
    };
    ParticipantFormHandler.prototype.deriveParticipantFormDataPaths = function (state) {
        var _this = this;
        return Array.from(new Set(state.rootCartItems.map(function (item) {
            var _a, _b;
            var waitListPaths = item.toWaitList ? (_b = (_a = _this.modelManager.getWaitingListEntityFormItem(state)) === null || _a === void 0 ? void 0 : _a.first()) === null || _b === void 0 ? void 0 : _b.getFieldPaths() : null;
            return waitListPaths !== null && waitListPaths !== void 0 ? waitListPaths : [];
        }).flat().concat([
            "form_data.form_field.course_participants",
            "form_data.form_field.personal_data",
            "form_data.form_field.extra_columns",
        ])));
    };
    ParticipantFormHandler.prototype.getState = function (state) {
        var _this = this;
        this.setRootParticipantIndices(state);
        this.setExtraArticleIndices(state);
        var formDataPaths = this.deriveParticipantFormDataPaths(state);
        formDataPaths.forEach(function (path) { return _this.setByPropsToState(_this.dirtyForm, state, path, []); });
        this.setByPropsToState(this.dirtyForm, state, "form_data.consent_agreement.consents");
        var consents = get(state, "form_data.consent_agreement.consents");
        if (size(consents)) {
            set(state, "form_data.consent_agreement.consents", omitBy(consents, function (v) { return v === undefined || v === null; }));
        }
        var newFormData = this.getFilteredFormData(state);
        var personal_data = get(newFormData, "form_data.form_field.personal_data", []);
        var allParticipantIndices = state.rootCartItems.reduce(function (indices, cartItem) { return indices.concat(cartItem.personalDataIndex); }, []);
        if (!allParticipantIndices.includes(state.billRecipientIndex)) {
            allParticipantIndices.push(state.billRecipientIndex);
        }
        state.participantIndices = invert(Array.from(personal_data)
            .map(function (x, index) { return allParticipantIndices.includes(String(index)) ? String(index) : null; })
            .filter(function (i) { return i !== null; }));
        return state;
    };
    ParticipantFormHandler.prototype.toJSON = function (sanitizedState) {
        return sanitizedState;
    };
    ParticipantFormHandler.prototype.getFilteredFormData = function (form, fieldPaths, switchablePathConstant) {
        if (fieldPaths === void 0) { fieldPaths = []; }
        if (switchablePathConstant === void 0) { switchablePathConstant = ""; }
        if (fieldPaths.length <= 0) {
            return form;
        }
        var switchableFields = get(form, switchablePathConstant);
        var filteredValues = fieldPaths.reduce(function (filteredValues, path) {
            if (switchablePathConstant && path.startsWith(switchablePathConstant))
                return filteredValues;
            var actualPath = path.match(/(\.date)$/) ? path.replace(/(\.date)$/, "") : path;
            var value = get(form, actualPath);
            if (value || ![null, undefined].includes(value)) {
                set(filteredValues, actualPath, value);
            }
            return filteredValues;
        }, {
            filtered: true,
            form_data: {
                consent_agreement: {},
                form_group: {},
                form_field: {}
            }
        });
        fieldPaths
            .filter(function (path) { return switchablePathConstant && path.startsWith(switchablePathConstant); })
            .map(function (path) { return path.replace(switchablePathConstant, ""); })
            .forEach(function (path) {
            if (get(switchableFields, path) !== "true")
                set(filteredValues, path, "");
        });
        return filteredValues;
    };
    ParticipantFormHandler.prototype.toRequestBody = function (dirtyState, fieldPaths, state) {
        var _this = this;
        var _a;
        var newFormData = this.getFilteredFormData(dirtyState, fieldPaths, "additional_props.switchable");
        var personal_data = get(newFormData, "form_data.form_field.personal_data", []);
        var extra_columns = get(newFormData, "form_data.form_field.extra_columns", []).map(function (x) { return (__assign({}, x)); });
        // state.participantIndices = invert(
        //     Array.from(personal_data).map((x, i) => x ? i : null).filter((i) => {
        //         return ![null, ""].includes(i as any);
        //     })
        // );
        var newPersonalData = [];
        var newExtraColumns = [];
        for (var index in personal_data) {
            var person = personal_data[index];
            if (!person || size(person) === 0) {
                continue;
            }
            ;
            newPersonalData.push(person);
            newExtraColumns.push((_a = extra_columns[index]) !== null && _a !== void 0 ? _a : {});
        }
        set(newFormData, "form_data.form_field.personal_data", newPersonalData);
        set(newFormData, "form_data.form_field.extra_columns", newExtraColumns);
        if (get(this.options, "isAdminIntegration", false) && !dirtyState.hasCoworkerConsent) {
            set(newFormData, "form_data.consent_agreement.consents", {});
        }
        remove(personal_data, function (x) { return !x || size(x) === 0; });
        var formDataPaths = this.deriveParticipantFormDataPaths(state);
        formDataPaths.forEach(function (path) { return _this.setByPropsToState(newFormData, dirtyState, path, []); });
        this.setByPropsToState(newFormData, dirtyState, "form_data.consent_agreement.consents");
        dirtyState.cartItems.forEach(function (cartItem) {
            if (!cartItem.booking) {
                return;
            }
            var index = cartItem.booking.personal_data_index;
            cartItem.booking.personal_data_index = dirtyState.participantIndices[index];
        });
        return dirtyState;
    };
    return ParticipantFormHandler;
}());
export { ParticipantFormHandler };
